import React from 'react'
const InnerHTMLHelper = ({ tagName, html, className }) =>
  React.createElement(tagName, { className: className, dangerouslySetInnerHTML: { __html: html } })
export default InnerHTMLHelper
